<div [ngClass]="getContainerClasses()">
  <!-- Label -->
  @if (label) {
  <label [for]="id" [ngClass]="getLabelClasses()">
    {{ label }}
    @if (required) {
    <span class="text-red-500 dark:text-red-400 ml-0.5">*</span>
    }
  </label>
  }

  <!-- Input Container -->
  <div class="relative">
    <!-- Left Icon -->
    @if (leftIcon) {
    <div [ngClass]="getIconWrapperClasses('left')">
      <app-icon [name]="leftIcon" [size]="size === 'sm' ? 16 : size === 'lg' ? 24 : 20" />
    </div>
    }

    <!-- Input Field -->
    <input [type]="inputType" [id]="id" [name]="name" [placeholder]="placeholder" [attr.autocomplete]="autocomplete"
      [attr.required]="required ? true : null" [disabled]="disabled" [attr.readonly]="readonly ? true : null"
      [attr.maxlength]="maxlength" [attr.minlength]="minlength" [attr.min]="min" [attr.max]="max"
      [attr.pattern]="pattern" [value]="value()" [ngClass]="getInputClasses()" (input)="onInput($event)"
      (focus)="onFocus($event)" (blur)="onBlur($event)" />

    <!-- Right Icon (not password toggle) -->
    @if (rightIcon && !showPasswordIcon) {
    <div [ngClass]="getIconWrapperClasses('right')">
      <app-icon [name]="rightIcon" [size]="size === 'sm' ? 16 : size === 'lg' ? 24 : 20" />
    </div>
    }

    <!-- Password Toggle Icon -->
    @if (showPasswordIcon) {
    <div [ngClass]="getPasswordToggleClasses()" (click)="togglePasswordVisibility()">
      <app-icon [name]="passwordToggleIcon" [size]="size === 'sm' ? 16 : size === 'lg' ? 24 : 20" />
    </div>
    }
  </div>

  <!-- Hint Text -->
  @if (hint && !error) {
  <p [ngClass]="getHintClasses()">
    {{ hint }}
  </p>
  }

  <!-- Error Message -->
  @if (error) {
  <p [ngClass]="getErrorClasses()">
    <app-icon name="circleAlert" [size]="12" />
    <span>{{ error }}</span>
  </p>
  }
</div>